<template>
  <div>
    <div class="user__list-offer__item">
      <div class="user__list-comment-wrp">
        <div class="user__list__dorm">
          <div class="user__list__dorm-img-wrp">
            <img :src="question.logo" class="user__list__dorm-img" alt="">
          </div>
          <div class="user__list__dorm-wrp">
            <p class="user__list__dorm-name">{{ question.name }}</p>
            <span class="user__list__dorm-location">
                {{ question.location }}</span>
          </div>
        </div>
      </div>
      <div class="user__list-comment">
        {{ question.text }}
        <div class="user__list-link" @click="showComment">
            <span class="comment-ico">
               <svg-icon type="icon-enter"/>
            </span>CEVAPLA
        </div>
      </div>

      <div class="answers">
        <div class="answers-box">
          <div class="user__list-offer__item comment" v-for="answer in question.answers" :key="answer.id">
            <div class="user__list-comment-wrp">
              <div class="user__list__dorm">
                <div class="user__list__dorm-img-wrp">
                  <img :src="answer.logo" class="user__list__dorm-img" alt="">
                </div>
                <div class="user__list__dorm-wrp">
                  <p class="user__list__dorm-name">{{ answer.name }}</p>
                  <span class="user__list__dorm-location">
                {{ answer.location }}</span>
                </div>
              </div>
            </div>

            <div class="user__list-comment">
              {{ answer.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="user__list-comment-box" v-show="open">
        <input type="text" class="user__list-comment-input" placeholder="Cevabınızı buraya yazın..">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionAnswer',

  props: {
    question: Object
  },
  data () {
    return {
      open: false
    }
  },

  methods: {
    showComment () {
      this.open = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/comments";
</style>
